import * as React from "react";
const UnMuteIcon = (props) => (
  <svg
    fill="#fff"
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M19,11 C19.5522847,11 20,11.4477153 20,12 C20,16.0792885 16.9468043,19.445465 13.0009551,19.9379871 L13,21 C13,21.5522847 12.5522847,22 12,22 C11.4477153,22 11,21.5522847 11,21 L11.0000487,19.9381123 C7.05371356,19.4460359 4,16.0796344 4,12 C4,11.4477153 4.44771525,11 5,11 C5.55228475,11 6,11.4477153 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,11.4477153 18.4477153,11 19,11 Z M12,2 C14.209139,2 16,3.790861 16,6 L16,12 C16,14.209139 14.209139,16 12,16 C9.790861,16 8,14.209139 8,12 L8,6 C8,3.790861 9.790861,2 12,2 Z M12,4 C10.8954305,4 10,4.8954305 10,6 L10,12 C10,13.1045695 10.8954305,14 12,14 C13.1045695,14 14,13.1045695 14,12 L14,6 C14,4.8954305 13.1045695,4 12,4 Z"
    />
  </svg>
);
export default UnMuteIcon;
